import { AxleChip, IAxleChipProps } from '@/components/displayFields/chips';
import { ReturnComponent } from '@/utils/reactTypes';
import { gql } from '@apollo/client';
import Person from '@mui/icons-material/Person';

export interface IPatientChip {
    id: string;
    fullName: string;
}

export const PatientChipFragment = gql`
    fragment PatientChipFragment on Patient {
        id
        fullName
    }
`;

export const PatientChip = ({
    patient: { id, fullName },
    showLink,
    ...rest
}: {
    patient: IPatientChip;
    showLink: boolean;
} & Omit<IAxleChipProps, 'label'>): ReturnComponent => (
    <AxleChip
        {...rest}
        icon={<Person />}
        label={fullName}
        link={showLink ? `/patients/${id}` : undefined}
        copyToClipboardValue={fullName}
    />
);
